<div class="container mx-auto px-4 py-10">
    <h2 class="text-2xl font-bold mb-4">Morning Meeting Update</h2>
    <form [formGroup]="meetingForm" (ngSubmit)="onSubmit()">
      <div class="mb-4">
        <label for="summary" class="block text-sm font-medium text-gray-700">Daily Task Summary</label>
        <textarea id="summary" formControlName="summary" rows="10" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"></textarea>
      </div>
      <div class="flex justify-between">
        <button type="button" (click)="onCancel()" class="w-1/2 mr-2 py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">Cancel</button>
        <button type="submit" class="w-1/2 ml-2 py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">Submit</button>
      </div>
    </form>
  </div>
